import { connect } from 'react-redux';
import * as R from 'ramda';
import LocationCheckboxList from './LocationCheckboxList';
import { fetchLocations } from '../store/sequencingWizardSlice';

const mapState = R.applySpec({
  locations: R.path(['loadingManagement', 'sequencingWizard', 'locations']),
  locationsLoading: R.path(['loadingManagement', 'sequencingWizard', 'locationsLoading']),
});

const mapDispatch = {
  fetchLocations,
};

export default connect(mapState, mapDispatch)(LocationCheckboxList);
